import { useAuth } from '@/common/AuthProvider';
import { DownOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Row } from 'antd';
import { CmnDataSelect } from "ccd-react-cmp";
import { LinerGroupType } from 'ccd-react-cmp/dist/property';
import dayjs, { Dayjs } from 'dayjs';
import React, { useState } from 'react';

const { RangePicker } = DatePicker;

const SearchMonthlyCriteria: React.FC<any> = ({ form, onSearchClick }) => {
    const [startValue, setStartValue] = useState<Dayjs | null>(null);
    const [endValue, setEndValue] = useState<Dayjs | null>(null);
    const linerGroup = useAuth().env.linerGroup.toLocaleLowerCase() as LinerGroupType;

    const disabledDate = (current: any) => {
        if (!startValue && !endValue) {
            return current.isAfter(dayjs())
        }
        if (startValue && endValue) {
            return current.isAfter(startValue.add(2, 'years'))
                || current.isBefore(endValue.subtract(2, 'years'))
                || current.isAfter(dayjs());
        }
        if (startValue) {
            return current.isAfter(startValue.add(2, 'years')) || current.isAfter(dayjs());
        }
        if (endValue) {
            return current.isBefore(endValue.subtract(2, 'years')) || current.isAfter(dayjs());
        }
        return false;
    };

    function onCalendarChange(dates: any, formatString: any, info: any) {
        if (dates) {
            info?.range === 'end' ? setEndValue(dates[1]) : setStartValue(dates[0]);
        } else {
            setStartValue(null);
            setEndValue(null);
        }

    }

    return (
        <>
            <Form layout='horizontal' form={form} onFinish={onSearchClick}>
                <Row gutter={24}>
                    <Col>
                        <Form.Item label='Period' name='period' rules={[{ required: true, message: 'Please select the period!' }]}>
                            <RangePicker
                                picker="month"
                                bordered={true}
                                onCalendarChange={onCalendarChange}
                                disabledDate={disabledDate} />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item label="From Currency" name='fromCurrency' rules={[{ required: true, message: 'Please select the from currency!' }]}>
                            <CmnDataSelect
                                allowClear
                                showSearch
                                category="currency"
                                linerGroup={linerGroup}
                                dropdownMatchSelectWidth={false}
                                carrierId={linerGroup === 'oocl' ? 1 : 99}
                                style={{width: 220}}
                                valueField="code"
                                displayField="code"
                                displayTpl={`\${item.code} - \${item.name}`}
                                tpl={`\${item.code} - \${item.name}`}
                                suffixIcon={<DownOutlined />}
                            />
                        </Form.Item>
                    </Col>
                    <Col>
                        <Form.Item label="To Currency"  name='toCurrency' rules={[{ required: true, message: 'Please select the to currency!' }]}>
                            <CmnDataSelect
                                allowClear
                                showSearch
                                category="currency"
                                linerGroup={linerGroup}
                                dropdownMatchSelectWidth={false}
                                carrierId={linerGroup === 'oocl' ? 1 : 99}
                                style={{width: 220}}
                                valueField="code"
                                displayField="code"
                                displayTpl={`\${item.code} - \${item.name}`}
                                tpl={`\${item.code} - \${item.name}`}
                                suffixIcon={<DownOutlined />}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24} style={{ textAlign: 'right' }}>
                        <Button style={{ width: '80px', marginRight: '24px'}} htmlType="reset">
                            Reset
                        </Button>
                        <Button style={{ width: '80px' }} type="primary" htmlType="submit">
                            Search
                        </Button>
                    </Col>
                </Row>
            </Form>
        </>
    )
}



export default SearchMonthlyCriteria